import Vue from 'vue'
import TemplateDialog from './template-dialog.vue'

export const cache = new Set()

export function openDialog(component) {
  const div = document.createElement('div')
  const el = document.createElement('div')

  const id = 'dialog-' + Math.random()

  div.appendChild(el)
  document.body.appendChild(div)

  const ComponentConstructor = Vue.extend(component)

  return (propsData = {}, parent = undefined) => {
    let instance = new ComponentConstructor({
      propsData,
      parent,
    }).$mount(el)

    const destroyDialog = () => {
      if (cache.has(id)) return
      if (instance && div.parentNode) {
        cache.add(id)
        instance.visible = false
        // 延时是为了在关闭动画执行完毕后卸载组件
        setTimeout(() => {
          cache.delete(id)
          instance.$destroy()
          instance = null
          div.parentNode && div.parentNode.removeChild(div)
        }, 600)
      }
    }

    // visible控制
    if (instance.visible !== undefined) {
      // 支持sync/v-model
      instance.$watch('visible', (val) => {
        !val && destroyDialog()
      })
      Vue.nextTick(() => (instance.visible = true))
    }

    return new Promise((resolve, reject) => {
      // emit 一个 done 事件关闭
      instance.$once('done', (data) => {
        resolve(data)
        destroyDialog()
        // console.log('-----------------done', data)
      })
      // emit 一个 close 事件取消
      instance.$once('close', (data) => {
        destroyDialog()
        // console.log('-------------reject', data)
        reject(data)
      })
    })
  }
}

export default function funcDialog(option) {
  return openDialog(TemplateDialog)({ ...option })
}
